<template>
  <!-- parentId必须为字符串 数字会报maxStack -->
  <tree-transfer
    ref="treeTransfer"
    :title="[$t('待选设备'), $t('已选设备')]"
    root-pid-value="0"
    pid="parentId"
    check-strictly-type="modular"
    check-strictly
    :from_data="fromData"
    :to_data="toData"
    :default-props="{label:'label'}"
    mode="transfer"
    highlight-current
    check-on-click-node
    height="100%"
    :placeholder="$t('输入关键字进行过滤')"
    filter
    open-all
    draggable
    :allow-drop="allowDrop"
    @node-drag-start="nodeDragStart"
    @add-btn="add"
    @remove-btn="remove"
    @left-check-change="leftCheckChange"
  >
    <span
      slot="content-left"
      slot-scope="{ node }"
      :class="{'none-tree': !node.label}"
    >{{ node.label }}</span>
  </tree-transfer>
</template>

<script>
export default {
  name: '',
  components: { treeTransfer: resolve => require(['el-tree-transfer'], resolve) },
  props: {
    // 右侧默认数据
    defaultToData: {
      type: Array,
      default() { []; }
    },
    // 左侧默认数据
    defaultFromData: {
      type: Array,
      default() { []; }
    }
  },
  data() {
    return {
      fromData: [],
      toData: [],
      type: ''
    };
  },
  watch: {
    toData: {
      handler() {
        this.$emit('getToData', this.toData);
      },
      deep: true
    },
    defaultToData: {
      handler(val) {
        this.toData = val;
        // this.$refs.treeTransfer.clearFilter();
      },
      immediate: true,
      deep: true
    },
    defaultFromData: {
      handler(val) {
        this.fromData = this.treeFilter(this.addDisabledLable(val), this.func);
        this.$nextTick(_ => {
          const el = this.$refs.treeTransfer?.$el;
          el && el.querySelectorAll('.el-checkbox__input.is-disabled').forEach(dom => {
            dom.parentElement.remove();
          });
        });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 树结构筛选，筛选掉默认勾选的
    treeFilter(tree, func) {
      // 使用map复制一下节点，避免修改到原树
      return tree.map(node => ({ ...node })).filter(node => {
        node.children = node.children && this.treeFilter(node.children, func);
        return func(node) || (node.children && node.children.length);
      });
    },
    func(node) {
      return !this.defaultToData.find(v => v.id === node.id);
    },
    // 左侧全选，不勾选父节点
    leftCheckChange(nodeObj, treeObj, checkAll) {
      if (checkAll) {
        const arr = this.$refs.treeTransfer.getChecked().leftNodes.filter(v => v.nodeType === 'DEVICE').map(v => v.id);
        this.$refs.treeTransfer.setChecked(arr);
      }
    },
    // 过滤树数据，不是根子集的都禁止选择
    addDisabledLable(data) {
      data?.forEach((node) => {
        if (node.nodeType !== 'DEVICE') {
          node.disabled = true;
          return this.addDisabledLable(node.children);
        } else {
          node.disabled = false;
        }
      });
      return data;
    },
    // 监听穿梭框组件添加
    add(fromData, toData, obj) {
      this.toData = [...this.toData, ...obj.nodes];
    },
    // 监听穿梭框组件移除
    remove(fromData, toData, obj) {
      console.log('remove', fromData, toData, obj);
    },
    nodeDragStart(type) {
      this.type = type;
    },
    allowDrop(draggingNode, dropNode, type) {
      if (this.type === 'right' && draggingNode.level === dropNode.level) { // 向上拖拽 || 向下拖拽
        return type === 'prev' || type === 'next';
      } else { // 不同级进行处理
        return false;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
::v-deep .el-checkbox.is-disabled{
  margin-right: 0;
}
::v-deep .custom-tree-node span{
  vertical-align: sub;
}
</style>
